<template>
  <div>
    <div class="nav_bar">
      <div @click="updateGroup">保存</div>
    </div>
    <div>邀请码：<input type="text" v-model="group.inviteCode" />
      <mt-switch v-model="enableInviteCode"></mt-switch>
    </div>
  </div>
</template>

<script>
import { Toast } from 'mint-ui'
export default {
  name: 'EditInviteCode',
  data: function () {
    return {
      group: {},
      enableInviteCode: false
    }
  },
  async created() {
    try {
      this.group = await this.$faApi.getGroupDetail(this.$route.params.groupId)
      this.enableInviteCode = this.group.enableInviteCode === 1
    } catch (err) {
      this.$faLoggr.error('EditInviteCode.vue:created', err)
    }
  },
  methods: {
    async updateGroup() {
      try {
        if (!this.group.inviteCode) {
          return Toast({
            message: '邀请码不能为空'
          })
        }
        await this.$faApi.updateGroup(this.$route.params.groupId, {
          inviteCode: this.group.inviteCode,
          enableInviteCode: +this.enableInviteCode
        })
        this.$router.push({ path: `/group/${this.$route.params.groupId}/setting` })
      } catch (err) {
        this.$faLoggr.error('EditInviteCode.vue:goToGroupSetting', err)
      }
    }
  }
}
</script>

<style scoped lang="scss">
  .nav_bar {
    margin-top: 20px;
  }
</style>
  